module.exports = __webpack_public_path__ + "media/images/league-4-d0e8267ab3bdb31cd93c0f7f1f2f73a6.jpg";